import { useState } from 'react'
import { useLang } from './hooks/useLang'
import Nav from './components/Nav'
import Hero from './components/Hero'
import VideoSection from './components/VideoSection'
import HowItWorks from './components/HowItWorks'
import InquirySection from './components/InquirySection'
import Subscribe from './components/Subscribe'
import Footer from './components/Footer'
import Modal from './components/Modal'

export default function App() {
  const { lang, t, setLang } = useLang()
  const [modal, setModal] = useState(null)

  function showInquiryModal() {
    setModal({ icon: '🚗', title: t.modal_inq_title, body: t.modal_inq_body })
  }

  function showInquiryError() {
    setModal({ icon: '⚠️', title: 'Send Failed', body: 'Something went wrong. Please try again or email key.eu@datium.xyz directly.' })
  }

  function showSubscribeModal() {
    setModal({ icon: '🎉', title: t.modal_sub_title, body: t.modal_sub_body })
  }

  return (
    <>
      <Nav t={t} lang={lang} setLang={setLang} />

      <Hero t={t} />

      <div className="glow-divider" />

      <VideoSection t={t} />

      <HowItWorks t={t} />

      <div className="glow-divider" />

      <InquirySection t={t} onInquirySubmit={showInquiryModal} onInquiryError={showInquiryError} />

      <Subscribe t={t} onSubscribe={showSubscribeModal} />

      <Footer t={t} />

      {modal && (
        <Modal
          icon={modal.icon}
          title={modal.title}
          body={modal.body}
          closeLabel={t.modal_close}
          onClose={() => setModal(null)}
        />
      )}
    </>
  )
}
